<template>
    <div>
        <div
            v-if="
                IntegrationProviderEnumData[providerKey]
                    .isHighlightedDuringOnboarding
            "
            class="relative"
        >
            <div class="absolute top-0 right-0">
                <div
                    class="text-xs font-semibold m-0.5 px-2 py-1 bg-primary text-primary-content rounded-bl-lg rounded-tr-lg"
                >
                    Recommended
                </div>
            </div>
        </div>
        <Card
            :noPadding="true"
            :noColors="true"
            :isHighlighted="
                IntegrationProviderEnumData[providerKey]
                    .isHighlightedDuringOnboarding
            "
            class="py-8 px-6 border bg-white shadow-xs"
            :class="{
                'cursor-default': !isConnected,
            }"
        >
            <template #content>
                <div
                    class="flex flex-col md:flex-row items-start md:items-center justify-between gap-4"
                    :class="{ 'opacity-50 cursor-default': isConnected }"
                >
                    <div class="flex items-center gap-4">
                        <Image
                            class="h-12 w-auto mx-auto object-contain"
                            :src="getThumbUrl(providerKey)"
                        />
                        <div class="text-lg font-semibold text-gray-900">
                            {{ getLabel(providerKey) }}
                        </div>
                    </div>
                    <div class="flex justify-end w-full md:w-auto">
                        <div v-if="isConnected">
                            <Button :disabled="true">Connected</Button>
                        </div>
                        <div v-else>
                            <Button
                                as="a"
                                :href="redirectUrl"
                                :color="isHighligthed ? 'info' : 'light'"
                                iconName="arrow-right"
                                iconRight
                            >
                                Connect
                            </Button>
                        </div>
                    </div>
                </div>
            </template>
        </Card>
    </div>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import Card from '@/Shared/Component/Card.vue'
    import {
        IntegrationProviderEnum,
        IntegrationProviderEnumData,
        type IntegrationProviderDataType,
    } from '@/Shared/AutoGenerated/Main'
    import Image from '@/Shared/Component/Image.vue'
    import Button from '@/Shared/Component/Button.vue'

    const emit = defineEmits(['onSuccess'])

    const props = defineProps({
        providerKey: {
            type: String as PropType<IntegrationProviderEnum>,
            required: true,
        },
        providers: {
            type: Array as PropType<IntegrationProviderDataType[]>,
            required: true,
        },
        isConnected: {
            type: Boolean,
            required: true,
        },
        isHighligthed: {
            type: Boolean,
            required: true,
        },
        redirectUrl: {
            type: String,
            default: null,
        },
    })

    // TODO: Reuse this duplicated bit of code, its all over the place
    const getThumbUrl = (providerKey: IntegrationProviderEnum) => {
        return props.providers.find((provider) => provider.key === providerKey)
            ?.thumbUrl
    }

    // TODO: Reuse this duplicated bit of code, its all over the place
    const getLabel = (providerKey: IntegrationProviderEnum) => {
        return props.providers.find((provider) => provider.key === providerKey)
            ?.label
    }
</script>
